
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorRemovePoint as ObiCursorRemovePointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-remove-point.js';
 
 
 

 
 export const ObiCursorRemovePoint = createComponent({
   react: React,
   tagName: 'obi-cursor-remove-point',
   elementClass: ObiCursorRemovePointElement,
   events: {
     
   }
  });
 
 